export default "__VITE_ASSET__256aebd3__"